import { useState } from "react";
import classNames from "classnames";
import { Spin } from "antd";
import { isVoid } from "@/shared/utils";
import { useCalendarEvents } from "@/features/calendar/model";
import { CalendarEventListDesktop } from "@/entities/calendar-event/ui";
import type { Dayjs } from "dayjs";
import type { FC } from "react";
import { DateValueRender } from "../calendar-date";
import styles from "./styles.module.scss";

type CellRenderProps = {
  date: Dayjs;
  cellWidth: number;
};

export const CellRender: FC<CellRenderProps> = ({ date, cellWidth }) => {
  const [containerActive, setContainerIsActive] = useState<boolean>(false);

  const { currentDateEvents, isFetching } = useCalendarEvents(date);

  const handleMouseEnter = () => {
    setContainerIsActive(true);
  };

  const handleMouseLeave = () => {
    setContainerIsActive(false);
  };

  if (isFetching) {
    return (
      <div className={styles.loading}>
        <Spin />
      </div>
    );
  }

  return (
    <div
      className={classNames("ant-picker-cell-inner", "ant-picker-calendar-date", {
        "ant-picker-calendar-date-today": date.isSame(new Date(), "day"),
      })}
    >
      <div className="ant-picker-calendar-date-value">
        <DateValueRender date={date} />
      </div>
      <div className="ant-picker-calendar-date-content">
        <div
          className={classNames(styles.container, {
            [styles["container-active"]]: containerActive,
          })}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={{ width: cellWidth }}
        >
          {!isVoid(currentDateEvents.importantNotes) && (
            <CalendarEventListDesktop date={date} events={currentDateEvents.importantNotes} />
          )}
          {!isVoid(currentDateEvents.birthdays) && (
            <CalendarEventListDesktop date={date} events={currentDateEvents.birthdays} />
          )}
          {!isVoid(currentDateEvents.anniversaries) && (
            <CalendarEventListDesktop date={date} events={currentDateEvents.anniversaries} />
          )}
          {!isVoid(currentDateEvents.notes) && (
            <CalendarEventListDesktop date={date} events={currentDateEvents.notes} />
          )}
        </div>
      </div>
    </div>
  );
};
